import { instance } from '@semantic-ui-react/event-stack'

export default instance
